import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * Avatar, the initials disc.
 *
 * CSS selector: `mobile/atoms.css` `.ds-avatar` (+ `--sm`, `--md`, `--lg`,
 * `--xl`, `--ink`, `--neutral`).
 *
 * Doctrine: the flat accent fill is the default and is the rationed accent used
 * as a brand moment. There is one accent voice, so the old gradient avatar is
 * retired rather than restyled. `ink` is the store monogram and `neutral` is
 * the quiet review-row treatment.
 *
 * An avatar almost always sits beside a visible name, so it is hidden from
 * assistive tech by default and only gains a role and a name when the consumer
 * passes `aria-label` explicitly.
 */
const AVATAR_SIZE = {
  base: null,
  sm: 'ds-avatar--sm',
  md: 'ds-avatar--md',
  lg: 'ds-avatar--lg',
  xl: 'ds-avatar--xl',
};

const AVATAR_FILL = {
  accent: null,
  ink: 'ds-avatar--ink',
  neutral: 'ds-avatar--neutral',
};

export const Avatar = React.forwardRef(function Avatar(
  { className, size = 'base', fill = 'accent', children, 'aria-label': ariaLabel, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      aria-hidden={ariaLabel ? undefined : true}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : undefined}
      className={cn('ds-avatar', AVATAR_SIZE[size], AVATAR_FILL[fill], className)}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Avatar;
